<template>
  <div class="education-section">
    <h2 class="text-2xl font-bold mb-4" :style="{ color: themeColor, borderBottom: `2px solid ${themeColor}`, paddingBottom: '0.5rem' }">
      Education
    </h2>
    <div v-for="(item, index) in section.data.items" :key="index" class="mb-4">
      <div class="flex justify-between items-start">
        <div>
          <h3 class="text-xl font-semibold">{{ item.degree || 'Degree' }}</h3>
          <p class="text-lg text-gray-700">{{ item.school || 'School Name' }}</p>
          <p v-if="item.description" class="text-gray-600 mt-1">{{ item.description }}</p>
        </div>
        <div class="text-right text-sm text-gray-600">
          <p>{{ item.startDate || 'Start' }} - {{ item.endDate || 'End' }}</p>
          <p v-if="item.location">{{ item.location }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    section: {
      type: Object,
      required: true
    },
    themeColor: {
      type: String,
      default: '#17803d'
    }
  }
}
</script>

